import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Action, ActionType } from 'src/app/models/action';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';

@Component({
  selector: 'app-favorite-button',
  templateUrl: './favorite-button.component.html',
  styleUrls: ['./favorite-button.component.scss', '../base-button.scss'],
})
export class FavoriteButtonComponent extends BaseButtonComponent implements OnChanges, OnInit, OnDestroy {
  private readonly amplitudeService = inject(AnalyticsService);

  @Input()
  recordId: string;
  @Input()
  isMoreOption: string;

  alreadyInFavorites: boolean;

  private favoriteAddedSubscription: Subscription;
  private favoriteRemovedSubscription: Subscription;

  ngOnInit() {
    this.favoriteFacade.favoriteAdded$.subscribe((favoriteAdded) => {
      if (favoriteAdded?.recordId === this.record.id) {
        this.alreadyInFavorites = true;
      }
    });

    this.favoriteFacade.favoriteRemoved$.subscribe((favoriteRemoved) => {
      if (favoriteRemoved?.recordId === this.record.id) {
        this.alreadyInFavorites = false;
      }
    });

    this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record === undefined) {
      this.record = { id: this.recordId };
      this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;
    } else {
      const record = changes.record;
      this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(record.currentValue.id) !== undefined;
    }
  }

  ngOnDestroy(): void {
    this.favoriteAddedSubscription?.unsubscribe();
    this.favoriteRemovedSubscription?.unsubscribe();
  }

  addToFavorites() {
    const action: Action = {
      type: ActionType.ADD_FAVORITE,
      recordId: this.record.id,
    };

    this.doAction(() => {
      this.favoriteFacade.postFavorite(this.record.id).subscribe({
        next: () => {
          this.alreadyInFavorites = true;
          this.amplitudeService.sendUserActionEvent('add_favorite', true);
        },
        error: () => this.amplitudeService.sendUserActionEvent('add_favorite', false),
      });
    }, action);
  }

  removeFromFavorites() {
    const favorite = this.favoriteFacade.getFavoriteByRecordId(this.record.id);

    this.favoriteFacade.deleteFavorite(favorite.recordId).subscribe({
      next: () => {
        this.alreadyInFavorites = false;
        this.amplitudeService.sendUserActionEvent('remove_favorite', true);
      },
      error: () => this.amplitudeService.sendUserActionEvent('remove_favorite', false),
    });
  }
}
